/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import isString from 'lodash/isString';
import { Map } from 'immutable';
import intlmap from './intlmap.json';


class ErrorIntl {
  constructor(intl, context) {
    this.intl = intl;
    this.context = context;
  }

  msgId(error, context = this.context) {
    if (!error) {
      return null;
    }

    let code;

    if (isString(error)) {
      code = error;
    } else if (Map.isMap(error)) {
      code = error.get('code');
    } else {
      code = error.code;
    }
    if (!code) {
      return null;
    }

    let key;
    if (context !== '') {
      key = `${context}.E.${code}`;
    } else {
      key = `E.${code}`;
    }
    if (intlmap[key]) {
      return intlmap[key];
    }
    return key;
  }

  msg(error, context = this.context) {
    const id = this.msgId(error, context);
    if (!id) {
      return null;
    }

    return this.intl.formatMessage({
      id,
      defaultMessage: id,
    });
  }
}

export default ErrorIntl;




// WEBPACK FOOTER //
// ./src/utils/errors/ErrorIntl.js